import { render, staticRenderFns } from "./app-header.html?vue&type=template&id=c53e98a6&scoped=true&external"
import script from "./app-header.vue?vue&type=script&lang=js"
export * from "./app-header.vue?vue&type=script&lang=js"
import style0 from "./app-header.css?vue&type=style&index=0&id=c53e98a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e98a6",
  null
  
)

export default component.exports